<script>
  import { createEventDispatcher } from 'svelte'
  import Icon from 'svelte-awesome/components/Icon.svelte'
  import star from 'svelte-awesome/icons/star'
  export let starColor
  export let initialRating = 5

  const dispatch = createEventDispatcher()

  let chosenRating = initialRating
  let tempRating
  let isNewRatingChosen = false

  function handleClick (num) {
    chosenRating = num
    isNewRatingChosen = true

    dispatch('setRating', {
      rating: num
    })
  }

  function handleMouseHover (rating) {
    if (rating > chosenRating) {
      isNewRatingChosen = false
      tempRating = chosenRating
      chosenRating = rating
    }
  }

  function handleMouseLeave (rating) {
    if (rating > tempRating && !isNewRatingChosen) {
      chosenRating = tempRating
    }
  }
</script>

<style>
  :global(.set-rating__wrapper-2bgvMK) {
    display: flex;
  }

  :global(.set-rating__wrapper-2bgvMK) :global(.star-3bWuVC) + :global(.star-3bWuVC) {
    margin-left: 5px;
  }
</style>

<div class="set-rating__wrapper-2bgvMK">
  {#each Array.from({ length: 5 }) as element, index}
    <div
      class="star-3bWuVC"
      on:click={() => handleClick(index + 1)}
      on:mouseenter={() => handleMouseHover(index + 1)}
      on:mouseleave={() => handleMouseLeave(index + 1)}>
      <Icon
        data={star}
        scale={2}
        style={`color:${index + 1 <= chosenRating ? `${starColor}` : '#eee'}; cursor: pointer;`} />
    </div>
  {/each}
</div>
